// extracted by mini-css-extract-plugin
module.exports = {"root":"GithubContainer_root__3BA5Y","box":"GithubContainer_box__Q0rpZ"};